// extracted by mini-css-extract-plugin
module.exports = {"apiName":"style_apiName__3ml5f","formContainer":"style_formContainer__3u2O9","addPlayerContainer":"style_addPlayerContainer__3Q89q","buttonWrapper":"style_buttonWrapper__1-Phe"};